
import {
    SET_BRG_DISCHARGED_PATIENTS,
    SET_EMAIL_PROMPT,
    SET_EMAIL_PROMPT_ONLY,
    SET_GENERATED_EMAIL,
    SET_FILTERED_EMAIL,
    SET_PT_SUMM_PROMPT,
    SET_PT_SUMM_PROMPT_ONLY,
    SET_PROMPT,
    SET_BRG_PATIENT_EMAIL_LOGS,
} from './types';

import { apiCallV2, servicesAPICall } from "../../utils/api";
import { removeDuplicates } from '../../utils';

export const GetBRGDSDischargedPatients = (page, count, filter, sort) => async (dispatch) => {

    const res = await servicesAPICall(
        "GET",
        "clinicient/get-indi-records",
        "",
        localStorage.getItem("access-token"),
        {
            page: page,
            limit: count,
            filters: filter,
            sort: sort,
        },
    );

    const list = res?.data?.brgDischargedPatients?.map((patient) => {
        return {
            ...patient,
            emailSentLogs: patient?.sentEmailLogs ? removeDuplicates(JSON.parse(patient?.sentEmailLogs), "id") : [],
            generatedEmails: patient?.emailsGenerated ? JSON.parse(patient?.emailsGenerated) : [],
        }
    })

    dispatch({
        type: SET_BRG_DISCHARGED_PATIENTS,
        data: {
            list: res?.data?.brgDischargedPatients ? list : [],
            count: res?.data?.count?.[0]?.["count(*)"] || 0
        }
    })

}

export const GetPrompt = (name, key = null) => async (dispatch) => {
    const res = await apiCallV2(
        "GET",
        "prompt/get",
        "",
        localStorage.getItem("access-token"),
        {
            name: name,
        },
    );

    dispatch({
        type: SET_PROMPT,
        data: {
            prompt: res?.data?.data?.prompt[0],
            name: name,
            key: key,
        }
    })

}

export const GetEmailPrompt = () => async (dispatch) => {
    const res = await apiCallV2(
        "GET",
        "prompt/get",
        "",
        localStorage.getItem("access-token"),
        {
            name: "generate-email-prompt",
        },
    );

    dispatch({
        type: SET_EMAIL_PROMPT,
        data: res?.data?.data?.prompt[0]
    })

}

export const GetPatientInfoSummaryPrompt = () => async (dispatch) => {
    const res = await apiCallV2(
        "GET",
        "prompt/get",
        "",
        localStorage.getItem("access-token"),
        {
            name: "brg-patient-summary",
        },
    );

    dispatch({
        type: SET_PT_SUMM_PROMPT,
        data: res?.data?.data?.prompt[0]
    })

}

export const SaveEmailPrompt = (id, prompt) => async (dispatch) => {
    const res = await apiCallV2(
        "POST",
        "prompt/save",
        {
            id: id,
            prompt: prompt
        },
        localStorage.getItem("access-token"),
    );

    dispatch({
        type: SET_EMAIL_PROMPT_ONLY,
        data: prompt
    })

    return res.data?.data?.success || false;
}

export const SavePatientInfoSummaryPrompt = (id, prompt) => async (dispatch) => {
    const res = await apiCallV2(
        "POST",
        "prompt/save",
        {
            id: id,
            prompt: prompt
        },
        localStorage.getItem("access-token"),
    );

    dispatch({
        type: SET_PT_SUMM_PROMPT_ONLY,
        data: prompt
    })

    return res.data?.data?.success || false;
}

export const GenerateEmail = (prompt, patient) => async (dispatch, getState) => {
    const { generatedEmails, brgDischargedPatients } = getState().Brg;

    const res = await servicesAPICall(
        "GET",
        "clinicient/generate-brg-patient-email",
        "",
        localStorage.getItem("access-token"),
        {
            prompt: prompt,
            patient: patient,
        },
    );


    if (res?.data?.data?.id > 0) {

        const newPatientList = brgDischargedPatients?.list?.map((dp, i) => {
            return dp?.id == patient ? {
                ...dp,
                generatedEmails: [...dp?.generatedEmails, {
                    ...res.data.data,
                    filtered: 0,
                    tracking_id: null
                }]
            } : dp;
        })

        dispatch({
            type: SET_BRG_DISCHARGED_PATIENTS,
            data: {
                list: [...newPatientList],
                count: brgDischargedPatients?.count
            }
        })

        // let temp = { ...generatedEmails };

        // if (temp[patient]?.length > 0) {
        //     temp[patient].unshift(res.data.data);
        // } else {
        //     temp[patient] = [res.data.data];
        // }

        // dispatch({
        //     type: SET_GENERATED_EMAIL,
        //     data: temp
        // })

        return {
            success: true,
            data: res.data.data,
        };
    } else {
        return {
            success: false,
        };
    }

}

export const GetPatientsGeneratedEmails = (patient, type = "unfiltered") => async (dispatch, getState) => {
    const { generatedEmails, filteredEmails } = getState().Brg;

    const emails = type == "filtered" ? filteredEmails : generatedEmails;

    if (!emails?.[patient?.id]?.length > 0) {
        const res = await servicesAPICall(
            "GET",
            "clinicient/get-patients-generated-emails",
            "",
            localStorage.getItem("access-token"),
            {
                patient: patient?.id,
                filtered: type == "filtered" ? 1 : 0
            },
        );

        if (res?.data?.data?.length > 0) {
            let temp = { ...emails };

            temp[patient?.id] = [...res.data.data];


            dispatch({
                type: type == "filtered" ? SET_FILTERED_EMAIL : SET_GENERATED_EMAIL,
                data: temp
            })

            return temp;
        }
    } else {
        return [];
    }
}

export const SuggestProgram = (prompt) => async (dispatch, getState) => {

    const res = await servicesAPICall(
        "GET",
        "clinicient/suggest-program-for-patient",
        "",
        localStorage.getItem("access-token"),
        {
            prompt: prompt,
        },
    );

    if (res.data?.success) {
        return {
            success: true,
            suggestProgram: JSON.stringify(res.data.data?.suggestedPrograms),
            summary: res.data.data?.summary
        };
    } else {
        return {
            success: false,
        };
    }

}

export const UpdatePatientSuggestedProgram = (patient, suggestedPrograms) => async (dispatch, getState) => {
    const res = await servicesAPICall(
        "POST",
        "clinicient/update-patient-suggested-programs",
        {
            patient: patient,
            suggestedPrograms: suggestedPrograms
        },
        localStorage.getItem("access-token"),
    );

    if (res.data.success && res.data.data == 1) {
        const { list, count } = getState().Brg?.brgDischargedPatients;

        let temp = list.map((p) => {
            return p?.id == patient ? {
                ...p,
                suggested_programs: suggestedPrograms
            } : p;
        })

        dispatch({
            type: SET_BRG_DISCHARGED_PATIENTS,
            data: {
                list: [...temp],
                count: count
            }
        })

        return true;
    } else {
        return false;
    }

}

export const SavePrompt = (oldPrompt, newPrompt) => async (dispatch) => {
    const res = await apiCallV2(
        "POST",
        "prompt/save",
        {
            id: oldPrompt?.id,
            prompt: newPrompt
        },
        localStorage.getItem("access-token"),
    );

    dispatch({
        type: SET_PROMPT,
        data: {
            prompt: {
                ...oldPrompt,
                text: newPrompt
            },
            name: oldPrompt?.name
        }
    })

    return res.data?.data?.success || false;
}

export const FilterEmailContent = (prompt, patient, oldEmail) => async (dispatch, getState) => {

    const { filteredEmails, brgDischargedPatients } = getState().Brg;

    const res = await servicesAPICall(
        "GET",
        "clinicient/generate-filtered-email",
        "",
        localStorage.getItem("access-token"),
        {
            prompt: prompt,
            patient: patient,
            oldEmail: oldEmail?.id
        },
    );



    if (res?.data?.data?.id > 0) {

        const newPatientList = brgDischargedPatients?.list?.map((dp, i) => {
            return dp?.id == patient ? {
                ...dp,
                generatedEmails: [...dp?.generatedEmails, {
                    ...res.data.data,
                    filtered: 1,
                    tracking_id: null
                }]
            } : dp;
        })


        dispatch({
            type: SET_BRG_DISCHARGED_PATIENTS,
            data: {
                list: [...newPatientList],
                count: brgDischargedPatients?.count
            }
        })

        // let temp = { ...filteredEmails };

        // if (temp[patient]?.length > 0) {
        //     temp[patient].unshift(res.data.data);
        // } else {
        //     temp[patient] = [res.data.data];
        // }

        // dispatch({
        //     type: SET_FILTERED_EMAIL,
        //     data: temp
        // })

        return {
            success: true,
            data: res.data.data,
        };
    } else {
        return {
            success: false,
        };
    }

}

export const SendEmail = (patient, email, html, subject, eventID, emailTemplate) => async (dispatch, getState) => {
    const { list, count } = getState().Brg?.brgDischargedPatients;

    const res = await servicesAPICall(
        "POST",
        "clinicient/send-patient-email",
        {
            patient: patient?.id,
            email: email?.id,
            html: html,
            subject: subject,
            to: patient?.email || null,
            receipient: patient?.email || null,
            eventID: eventID,
            emailTemplate: emailTemplate,
        },
        localStorage.getItem("access-token"),
    );

    const newLog = {
        date_clicked: null,
        date_delivered: null,
        date_opened: null,
        date_registered: null,
        date_sent: new Date(),
        email: email?.id,
        email_content: html,
        email_type: emailTemplate?.tag + (emailTemplate?.version > 1 ? ("-v" + emailTemplate?.version) : ""),
        event_id: eventID,
        id: res?.data?.data?.logEmail?.[0],
        patient_id: patient?.id,
        tracking_id: res?.data?.data?.paubox?.data?.sourceTrackingId,
    }

    dispatch({
        type: SET_BRG_DISCHARGED_PATIENTS,
        data: {
            list: list?.map((p) => {
                return p?.id == patient?.id ? {
                    ...p,
                    emailSentLogs: [...p?.emailSentLogs, newLog]
                } : p;
            }),
            count: count
        }
    })

    return res?.data?.success || false;
}

export const GetBRGPatientEmailLogs = (page, count, filter = {}, sort = null) => async (dispatch) => {
    const res = await apiCallV2(
        "GET",
        "brg/patient-email-log/get",
        "",
        localStorage.getItem("access-token"),
        {
            page: page,
            limit: count,
            filters: filter,
            sort: sort,
        },
    );

    dispatch({
        type: SET_BRG_PATIENT_EMAIL_LOGS,
        data: {
            list: res.data.brgPatientEmailLogs,
            count: res.data.count[0]["count(*)"]
        }
    })

}